import { Box } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { usePermissions } from '~/entities/common/viewer'
import { Button } from '~/shared/ui/Buttons'
import { PlusIcon } from '~/shared/ui/Icons'
import { Modal, useModal } from '~/shared/ui/Modal'
import { FormValues } from '../EditForm/model'
import { Form } from './Form'

type AddModalProps = {
  onSuccess: (formValues: FormValues, closeModal: () => void) => void
  isSubmitting: boolean
}

export function AddModal({ onSuccess, isSubmitting }: AddModalProps) {
  const { t } = useTranslation()
  const { isModalShow, closeModal, openModal } = useModal()

  const { canCarDocumentsUpdate } = usePermissions()

  const handleOnSuccess = (formValues: FormValues) => {
    onSuccess(formValues, closeModal)
  }

  return (
    <>
      <Button
        onClick={openModal}
        show={canCarDocumentsUpdate}
        startDecorator={<PlusIcon />}
      >
        {t('button.add')}
      </Button>

      <Modal
        title={t('add parking card')}
        isShow={isModalShow}
        onCancel={closeModal}
        dialogProps={{
          sx: {
            minWidth: '600px',
            maxWidth: '600px',
          },
        }}
      >
        <Box sx={{ padding: '4px' }}>
          <Form onSuccess={handleOnSuccess} isSubmitting={isSubmitting} />
        </Box>
      </Modal>
    </>
  )
}
